<div class="containeer-fluid">
  <div class="row">
    <div class="col-lg-1 col-12 px-0">
      <div class="d-flex myside-menu-container">
        <div
          class="nav flex-lg-column nav-pills px-1"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <button
            (click)="goBack()"
            class="nav-link btn-link"
            type="button"
            role="tab"
          >
            <i class="bx bx-arrow-back fs-5 text-primary"></i>
          </button>

          <button
            class="nav-link active"
            id="usecase-list-tab"
            data-bs-toggle="pill"
            data-bs-target="#usecase-list"
            type="button"
            role="tab"
            aria-controls="usecase-list"
            aria-selected="false"
            (click)="activetab = 'usecase-list-tab'; getUsecaseDataList()"
          >
            <i
              class="fa fa-list"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="list"
            ></i>
          </button>

          <button
            class="nav-link btn-link"
            id="usecase-dashboard-tab"
            data-bs-toggle="pill"
            data-bs-target="#usecase-dashboard"
            type="button"
            role="tab"
            aria-controls="usecase-dashboard"
            aria-selected="false"
            (click)="
              activetab = 'usecase-dashboard-tab';
              resetImgDoc();
              setDefaultvalue()
            "
          >
            <i
              class="bi bi-card-heading fs-5 p-0"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="data entry"
            >
            </i>
          </button>
        </div>
      </div>
    </div>

    <div class="col-lg-11 col-12 ps-0 my-margin-left">
      <div class="tab-content" id="v-pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="usecase-list"
          role="tabpanel"
          aria-labelledby="usecase-list-tab"
        >
          <!-- list  -->
          <div class="container-fluid">
            <!-- Home -->
            <div class="row">
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-item-center mb-3"
              >
                <div>
                  <h5 class="d-flex mb-0">
                    <i class="fa fa-list text-primary me-2 mt-1"></i>
                    <p class="wrap-text mb-0">
                      {{ usecaseSchema["name"] }} >
                      {{ "UsecaseData.USECASE.LIST.TITLE" | translate }}
                    </p>
                  </h5>
                </div>
                <div>
                  <app-list-header
                    [$parent]="getSelf()"
                    class="mt-1"
                  ></app-list-header>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="card pb-3">
                  <div class="search-card compact-inputs dropdown-pd-none">
                    <mat-card-header class="search-card-header">
                      <!--  search panel start-->
                      <button
                        mat-stroked-button
                        color="primary"
                        class="ms-1"
                        (click)="toggleSearchInputs()"
                        [matTooltip]="
                          showSearchInputs
                            ? ('UsecaseData.USECASE.LIST.HIDE_SEARCH'
                              | translate)
                            : ('UsecaseData.USECASE.LIST.SHOW_SEARCH'
                              | translate)
                        "
                      >
                        <mat-icon>tune</mat-icon>
                        <span>Filter</span>
                      </button>
                    </mat-card-header>

                    <mat-card-content>
                      <div *ngIf="showSearchInputs">
                        <div class="row align-items-center">
                          <ng-container *ngFor="let e of attributeList">
                            <!-- REF KEY 1 (ng-select with search) -->
                            <div
                              *ngIf="e['refKey'] == 1"
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-select
                                      [(ngModel)]="searchValues[e.code]"
                                      [compareWith]="compareFn"
                                      [placeholder]="
                                        searchValues[e.code]
                                          ? ''
                                          : '--Select ' + e.label + ' --'
                                      "
                                      [panelClass]="'clear-icon-compact-panel'"
                                      (selectionChange)="
                                        onSearchReferenceValueChange1(
                                          e,
                                          $event.value
                                        )
                                      "
                                    >
                                      <mat-option>
                                        <ngx-mat-select-search
                                          #searchVar
                                          [placeholderLabel]="
                                            'Search ' + e.label + '...'
                                          "
                                          noEntriesFoundLabel="No matches found"
                                        >
                                        </ngx-mat-select-search>
                                      </mat-option>
                                      <mat-option [value]="null"
                                        >-- None --</mat-option
                                      >
                                      <ng-container
                                        *ngFor="
                                          let item of getFilteredData(
                                            form.preload?.[e.primaryUsecase] ||
                                              []
                                          )
                                        "
                                      >
                                        <mat-option
                                          *ngIf="
                                            filterFn(searchVar.value, item)
                                          "
                                          [value]="item.id"
                                        >
                                          {{ item._val }}
                                        </mat-option>
                                      </ng-container>
                                    </mat-select>
                                    <mat-label>{{ e.label }}</mat-label>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- DATE/IDATE FIELD -->
                            <div
                              *ngIf="
                                e['type'] === 'date' || e['type'] === 'idate'
                              "
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <input
                                      matInput
                                      type="date"
                                      #dateInput
                                      [(ngModel)]="searchValues[e.code]"
                                      (change)="
                                        onValueChange(
                                          e,
                                          $any($event).target.value
                                        )
                                      "
                                    />
                                    <button
                                      mat-icon-button
                                      matSuffix
                                      type="button"
                                      class="icon-pd-none"
                                      (click)="dateInput.showPicker()"
                                      aria-label="Open date picker"
                                    >
                                      <mat-icon
                                        class="icon-compact text-secondary"
                                        >event</mat-icon
                                      >
                                    </button>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- DATE AND TIME FIELD -->
                            <div
                              *ngIf="e['type'] === 'dateandtime'"
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <input
                                      matInput
                                      type="datetime-local"
                                      #dateTimeInput
                                      [(ngModel)]="searchValues[e.code]"
                                      (change)="
                                        onValueChange(
                                          e,
                                          $any($event).target.value
                                        )
                                      "
                                    />
                                    <button
                                      mat-icon-button
                                      matSuffix
                                      type="button"
                                      (click)="dateTimeInput.showPicker()"
                                      class="icon-pd-none"
                                      aria-label="Open picker"
                                    >
                                      <mat-icon
                                        class="icon-compact text-secondary"
                                        >calendar_month</mat-icon
                                      >
                                    </button>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- TIME/ITIME FIELD -->
                            <div
                              *ngIf="
                                e['type'] === 'time' || e['type'] === 'itime'
                              "
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <input
                                      matInput
                                      type="time"
                                      #tInput
                                      [(ngModel)]="searchValues[e.code]"
                                      (change)="
                                        onValueChange(
                                          e,
                                          $any($event).target.value
                                        )
                                      "
                                    />
                                    <button
                                      mat-icon-button
                                      matSuffix
                                      type="button"
                                      class="icon-pd-none"
                                      (click)="tInput.showPicker()"
                                      aria-label="Open time picker"
                                    >
                                      <mat-icon
                                        class="icon-compact text-secondary"
                                        >access_time</mat-icon
                                      >
                                    </button>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- PASSWORD FIELD -->
                            <div
                              *ngIf="e['type'] === 'password'"
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <input
                                      matInput
                                      [type]="
                                        e.showPassword ? 'text' : 'password'
                                      "
                                      [ngModel]="searchValues[e.code] || ''"
                                      (ngModelChange)="onValueChange(e, $event)"
                                    />
                                    <button
                                      mat-icon-button
                                      matSuffix
                                      class="icon-pd-none"
                                      (click)="togglePassword(e)"
                                      type="button"
                                      aria-label="Toggle password visibility"
                                    >
                                      <mat-icon
                                        class="icon-compact text-secondary pe-2"
                                        style="font-size: 8px"
                                      >
                                        {{
                                          e.showPassword
                                            ? "visibility_off"
                                            : "visibility"
                                        }}
                                      </mat-icon>
                                    </button>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- LIST FIELD -->
                            <div
                              *ngIf="e['type'] === 'list'"
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-select
                                      [(ngModel)]="searchValues[e.code]"
                                      [panelClass]="'clear-icon-compact-panel'"
                                      [placeholder]="
                                        searchValues[e.code]
                                          ? ''
                                          : '--Select ' + e.label + ' --'
                                      "
                                    >
                                      <mat-option>
                                        <ngx-mat-select-search
                                          #dynamicSearch
                                          [placeholderLabel]="
                                            'Search ' + e.label + '...'
                                          "
                                          noEntriesFoundLabel="No matches found"
                                        >
                                        </ngx-mat-select-search>
                                      </mat-option>
                                      <mat-option [value]="null"
                                        >-- None --</mat-option
                                      >
                                      <ng-container
                                        *ngFor="let item of e['values']"
                                      >
                                        <mat-option
                                          *ngIf="
                                            !dynamicSearch.value ||
                                            (item?.self
                                              ? item.self
                                                  .toLowerCase()
                                                  .includes(
                                                    dynamicSearch.value.toLowerCase()
                                                  )
                                              : item
                                                  ?.toString()
                                                  .toLowerCase()
                                                  .includes(
                                                    dynamicSearch.value.toLowerCase()
                                                  ))
                                          "
                                          [value]="
                                            item?.self ? item.self : item
                                          "
                                        >
                                          {{ item?.self ? item.self : item }}
                                        </mat-option>
                                      </ng-container>
                                    </mat-select>
                                    <mat-label>{{ e.label }}</mat-label>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- BOOLEAN FIELD -->
                            <div
                              *ngIf="e['type'] === 'boolean'"
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <mat-select
                                      [(ngModel)]="searchValues[e.code]"
                                    >
                                      <mat-option [value]="undefined">
                                        {{
                                          "UsecaseData.USECASE.LIST.BOOLEAN_SELECT"
                                            | translate
                                        }}
                                      </mat-option>
                                      <mat-option [value]="1">
                                        {{
                                          "UsecaseData.USECASE.LIST.TRUE"
                                            | translate
                                        }}
                                      </mat-option>
                                      <mat-option [value]="0">
                                        {{
                                          "UsecaseData.USECASE.LIST.FALSE"
                                            | translate
                                        }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- OTHER INPUT FIELDS (text, number, email, etc.) -->
                            <div
                              *ngIf="
                                e['refKey'] != 1 &&
                                ![
                                  'list',
                                  'file',
                                  'doc',
                                  'map',
                                  'location',
                                  'boolean',
                                  'date',
                                  'idate',
                                  'dateandtime',
                                  'time',
                                  'itime',
                                  'password',
                                ].includes(e['type'])
                              "
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{ e.label }}</mat-label>
                                    <input
                                      matInput
                                      [type]="getInputType(e.type)"
                                      [(ngModel)]="searchValues[e.code]"
                                      (ngModelChange)="onValueChange(e, $event)"
                                    />
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="getDescription(e)"
                                  matTooltipPosition="right"
                                  [attr.aria-label]="e.label"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>
                          </ng-container>

                          <!-- SEARCH + RESET BUTTONS -->
                          <div
                            class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <button
                                mat-stroked-button
                                color="primary"
                                class="me-2"
                                (click)="getUsecaseDataList()"
                              >
                                <mat-icon>search</mat-icon>
                                <span>{{
                                  "UsecaseData.USECASE.LIST.ACTIONS.SEARCH"
                                    | translate
                                }}</span>
                              </button>
                              <button
                                mat-stroked-button
                                color="warn"
                                (click)="resetSearch()"
                              >
                                <i class="fa fa-eraser eraser-warn-dark"></i>
                                <span class="ms-2">{{
                                  "UsecaseData.USECASE.LIST.ACTIONS.RESET"
                                    | translate
                                }}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card-content>

                    <!-- DYNAMIC SEARCH ATTRIBUTES card end -->
                    <!-- ALERT -->
                    <mat-card-content>
                      <div class="mt-2">
                        <p
                          *ngIf="form['error'] == false && form['message']"
                          class="mb-1"
                        >
                          <app-ncs-alert
                            [message]="form['message']"
                            type="success"
                          ></app-ncs-alert>
                        </p>

                        <p
                          *ngIf="form['error'] == true && form['message']"
                          class="mb-1"
                        >
                          <app-ncs-alert
                            [message]="form['message']"
                            type="danger"
                          ></app-ncs-alert>
                        </p>
                      </div>
                      <div
                        class="d-flex justify-content-start flex-wrap gap-2 mb-2 mt-3"
                      >
                        <!-- Excel Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.EXCEL' | translate
                          "
                          (click)="exportData()"
                        >
                          <mat-icon class="me-1">description</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.EXCEL" | translate
                          }}
                        </button>

                        <!-- PDF Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.PDF' | translate
                          "
                          (click)="exportPDFDataEmail()"
                        >
                          <mat-icon class="me-1">picture_as_pdf</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.PDF" | translate
                          }}
                        </button>

                        <!-- Upload Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.UPLOAD'
                              | translate
                          "
                          (click)="csvfileInput.click()"
                        >
                          <mat-icon class="me-1">cloud_upload</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.UPLOAD"
                              | translate
                          }}
                        </button>
                        <input
                          type="file"
                          #csvfileInput
                          class="d-none"
                          accept="csv"
                          (change)="onCsvFileUpload($event)"
                        />

                        <!-- Sample CSV Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.SAMPLE_CSV'
                              | translate
                          "
                          (click)="exportSampleData()"
                        >
                          <mat-icon class="me-1">download</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.SAMPLE_CSV"
                              | translate
                          }}
                        </button>

                        <button
                          mat-stroked-button
                          color="primary"
                          matTooltipPosition="above"
                          [routerLink]="['/upload-logs', usecaseId]"
                          [matTooltip]="'BUTTONS.UPLOAD_ERROR_LOGS' | translate"
                          class="d-flex align-items-center"
                        >
                          <mat-icon class="me-1">history</mat-icon>
                          {{ "BUTTONS.UPLOAD_ERROR_LOGS" | translate }}
                        </button>

                        <!-- Add Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.ADD' | translate
                          "
                          (click)="
                            changeTab('usecase-dashboard-tab');
                            resetImgDoc();
                            setDefaultvalue()
                          "
                        >
                          <mat-icon class="me-1">add</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.ADD" | translate
                          }}
                        </button>

                        <!-- Delete Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                              | translate
                          "
                          (click)="Deleteall()"
                        >
                          <mat-icon class="me-1 icon-compact">delete</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.ACTIONS.DELETE"
                              | translate
                          }}
                        </button>

                        <!-- Archive/List Toggle Buttons -->

                        <!-- Archive Button (shows when main list is active) -->
                        <button
                          *ngIf="!isArchivedlistTabActive"
                          mat-stroked-button
                          color="primary"
                          [title]="
                            'UsecaseData.USECASE.LIST.TABS.ARCHIVED' | translate
                          "
                          (click)="toggleTab('archivedlist')"
                        >
                          <mat-icon class="me-1">archive</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.TABS.ARCHIVED" | translate
                          }}
                        </button>

                        <!-- List Button (shows when archive is active) -->
                        <button
                          *ngIf="isArchivedlistTabActive"
                          mat-stroked-button
                          color="primary"
                          [title]="
                            'UsecaseData.USECASE.LIST.TABS.LIST' | translate
                          "
                          (click)="toggleTab('mainlist')"
                        >
                          <mat-icon class="me-1">list</mat-icon>
                          {{ "UsecaseData.USECASE.LIST.TABS.LIST" | translate }}
                        </button>

                        <!-- Trash Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="ms-1"
                          [title]="
                            'UsecaseData.USECASE.LIST.TABS.TRASH' | translate
                          "
                          (click)="toggleTab('trashlist')"
                        >
                          <mat-icon class="me-1">delete_outline</mat-icon>
                          {{
                            "UsecaseData.USECASE.LIST.TABS.TRASH" | translate
                          }}
                        </button>
                      </div>
                    </mat-card-content>
                    <mat-card-content>
                      <div class="tab-content mt-2" id="pills-tabContent">
                        <div
                          class="tab-pane fade"
                          [class.show]="
                            !isArchivedlistTabActive && !isTrashTabActive
                          "
                          [class.active]="
                            !isArchivedlistTabActive && !isTrashTabActive
                          "
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div class="table-container">
                            <div class="table-responsive table-scrollable">
                              <table
                                class="table table-bordered table-hover table-sticky-header"
                              >
                                <thead>
                                  <tr>
                                    <th class="text-center">
                                      <mat-checkbox
                                        [(ngModel)]="masterSelected"
                                        (change)="selectAll()"
                                        color="primary"
                                      >
                                      </mat-checkbox>
                                    </th>
                                    <th class="text-center">
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.EDIT"
                                          | translate
                                      }}
                                    </th>
                                    <th class="text-center">
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.SERIAL_NO"
                                          | translate
                                      }}
                                    </th>
                                    <th
                                      *ngFor="
                                        let e of attributeList;
                                        let i = index
                                      "
                                      (click)="sortTable(e.code)"
                                    >
                                      {{ getFilterLable(e["label"]) }}
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'ASC'
                                        "
                                        class="fa fa-sort-up ms-1"
                                      ></i>
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'DESC'
                                        "
                                        class="fa fa-sort-down ms-1"
                                      ></i>
                                      <i
                                        *ngIf="sortedField !== e.code"
                                        class="fa fa-sort ms-1"
                                      ></i>
                                    </th>

                                    <!-- Tag Column Header -->
                                    <th *ngIf="enabletag === 1">
                                      {{ "COMMON.TAGS" | translate }}
                                    </th>

                                    <th>
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.ACTIONS"
                                          | translate
                                      }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let e of filteredData;
                                      let i = index
                                    "
                                  >
                                    <td
                                      class="text-center"
                                      [ngStyle]="{
                                        'min-width':
                                          filteredData.length > 5
                                            ? '50px'
                                            : '0px',
                                      }"
                                    >
                                      <mat-checkbox
                                        [(ngModel)]="e.selected"
                                        color="primary"
                                        (change)="checkIfAllSelected()"
                                      >
                                      </mat-checkbox>
                                    </td>
                                    <td
                                      class="text-center"
                                      [ngStyle]="{
                                        'min-width':
                                          filteredData.length > 5
                                            ? '50px'
                                            : '0px',
                                      }"
                                    >
                                      <div
                                        class="d-flex align-item-center justify-content-center"
                                      >
                                        <div>
                                          <button
                                            mat-icon-button
                                            color="primary"
                                            class="icon-clean icon-width"
                                            [matTooltip]="
                                              'UsecaseData.USECASE.LIST.ACTIONS.EDIT'
                                                | translate
                                            "
                                            *ngIf="form.data.readOnly != 'true'"
                                            (click)="
                                              getUsecaseData(e['id']);
                                              changeTab('usecase-dashboard-tab')
                                            "
                                          >
                                            <mat-icon class="icon-compact"
                                              >edit</mat-icon
                                            >
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      class="text-center"
                                      [ngStyle]="{
                                        'min-width':
                                          filteredData.length > 5
                                            ? '50px'
                                            : '0px',
                                      }"
                                    >
                                      {{ pageIndex(i) }}
                                    </td>
                                    <td
                                      *ngFor="
                                        let at of attributeList;
                                        let i = index
                                      "
                                    >
                                      <span
                                        *ngIf="
                                          at['type'] === 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'doc' &&
                                          at['type'] !== 'location'
                                        "
                                        >{{ e[at["code"]] | json }}
                                      </span>
                                      <span
                                        *ngIf="
                                          at['type'] != 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'doc' &&
                                          at['type'] != 'textarea' &&
                                          at['type'] != 'email' &&
                                          at['type'] != 'text' &&
                                          at['type'] !== 'boolean' &&
                                          at['type'] !== 'location' &&
                                          at['type'] != 'list' &&
                                          at['type'] != 'map' &&
                                          at['type'] != 'time' &&
                                          at['type'] != 'itime' &&
                                          at['type'] !== 'dateandtime' &&
                                          at['type'] != 'json' &&
                                          at['type'] !== 'number' &&
                                          at['type'] != 'tag'
                                        "
                                        >{{
                                          getString(e[at["code"]], at["type"])
                                        }}</span
                                      >
                                      <span
                                        *ngIf="at['type'] === 'dateandtime'"
                                      >
                                        {{
                                          at["depAttribute"]
                                            ? getString(
                                                e[at["depAttribute"]],
                                                at["type"]
                                              )
                                            : getString(
                                                e[at["code"]],
                                                at["type"]
                                              )
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'boolean'">
                                        {{
                                          e[at["code"]] === 1
                                            ? ("UsecaseData.USECASE.LIST.TRUE"
                                              | translate)
                                            : e[at["code"]] === 0
                                              ? ("UsecaseData.USECASE.LIST.FALSE"
                                                | translate)
                                              : ""
                                        }}
                                      </span>
                                      <span
                                        *ngIf="at['type'] === 'list'"
                                        [title]="e[at['code']]"
                                      >
                                        {{
                                          e[at["code"]] === null ||
                                          e[at["code"]] == undefined ||
                                          e[at["code"]] == "undefined"
                                            ? ""
                                            : e[at["code"]]
                                        }}
                                      </span>
                                      <span *ngIf="at['type'] === 'map'">
                                        {{
                                          e[at["code"]] === null ||
                                          e[at["code"]] === undefined ||
                                          e[at["code"]] === "undefined"
                                            ? ""
                                            : e[at["code"]]
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'location'">
                                        <ng-container
                                          *ngIf="
                                            getLocationObject(
                                              at['depAttribute']
                                                ? e[at['depAttribute']]
                                                : e[at['code']]
                                            ) as loc
                                          "
                                        >
                                          <a
                                            [href]="
                                              'https://www.google.com/maps?q=' +
                                              loc.lat +
                                              ',' +
                                              loc.lng
                                            "
                                            target="_blank"
                                            style="text-decoration: none"
                                            >{{ loc.lat }},{{ loc.lng }}
                                          </a>
                                        </ng-container>
                                      </span>
                                      <span
                                        *ngIf="
                                          at['type'] != 'list' &&
                                          at['type'] != 'object' &&
                                          at['type'] !== 'location' &&
                                          at['type'] === 'file'
                                        "
                                      >
                                        <a
                                          href="{{ getAppDoc(e[at['code']]) }}"
                                          target="_blank"
                                        >
                                          <img
                                            src="{{
                                              getAppDocThumbnail(e[at['code']])
                                            }}"
                                            width="50px"
                                          />
                                        </a>
                                      </span>

                                      <div
                                        *ngIf="at['type'] === 'textarea'"
                                        class="custom-textarea"
                                        [innerHTML]="
                                          getSanitizedHtml(e[at['code']])
                                        "
                                      ></div>

                                      <!--Json -->
                                      <div
                                        *ngIf="at['type'] === 'json'"
                                        class="custom-textarea"
                                        [innerHTML]="
                                          getSanitizedHtml(e[at['code']])
                                        "
                                      ></div>

                                      <span *ngIf="at['type'] === 'email'">
                                        <a
                                          href="mailto:{{ e[at['code']] }}"
                                          target="_blank"
                                        >
                                          {{ e[at["code"]] }}
                                        </a>
                                      </span>
                                      <!-- Text / Number with QR/Barcode Support -->
                                      <span
                                        *ngIf="
                                          at['type'] === 'text' ||
                                          at['type'] === 'number'
                                        "
                                        class="d-block"
                                      >
                                        <!-- QR Code -->
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'qr' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'qr',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <qrcode
                                                [qrdata]="
                                                  e[at['code']].toString()
                                                "
                                                [width]="50"
                                                [errorCorrectionLevel]="'M'"
                                              ></qrcode>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #2e2e2e;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>

                                        <!-- Barcode -->
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'bar' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'bar',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <ngx-barcode6
                                                [bc-value]="
                                                  e[at['code']].toString()
                                                "
                                                bc-format="CODE128"
                                                [bc-display-value]="false"
                                                [bc-width]="0.8"
                                                [bc-height]="20"
                                              ></ngx-barcode6>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #363636;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>

                                        <!-- Plain Text (no code) — left aligned -->
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'none' ||
                                            !at['codeType'] ||
                                            !e[at['code']]
                                          "
                                        >
                                          <span
                                            class="text-start d-block"
                                            [title]="e[at['code']]"
                                            >{{
                                              e[at["code"]] | truncate: 40
                                            }}</span
                                          >
                                        </ng-container>
                                      </span>

                                      <span *ngIf="at['type'] === 'time'">
                                        {{
                                          at["depAttribute"]
                                            ? getString1(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                            : getString1(
                                                e[at["code"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'itime'">
                                        {{
                                          at["depAttribute"]
                                            ? getStringitime(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                            : getStringitime(
                                                e[at["code"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                        }}
                                      </span>

                                      <span
                                        *ngIf="
                                          at['type'] != 'list' &&
                                          at['type'] != 'object' &&
                                          at['type'] !== 'file' &&
                                          at['type'] !== 'location' &&
                                          at['type'] === 'doc' &&
                                          at['type'] != 'tag'
                                        "
                                      >
                                        <a
                                          href="{{ getAppDoc(e[at['code']]) }}"
                                          target="_blank"
                                        >
                                          <img
                                            src="{{
                                              getAppDocThumbnail(e[at['code']])
                                            }}"
                                            width="50px"
                                          />
                                        </a>
                                      </span>

                                      <!-- <span *ngIf="enabletag === 1 && at['type'] === 'tag'" class="d-flex align-items-start gap-2">
                                <button type="button" class="btn btn-light overflow-hidden text-truncate"
                                  data-bs-toggle="modal" data-bs-target="#tagsModal" (click)="allAttribute(e, i)"
                                  [title]="getCleanTag(e['tag'])">
                                  <ng-container *ngIf="getCleanTag(e['tag']) !== 'Add Tags'; else showTagIcon">
                                    {{ getCleanTag(e['tag']) }}
                                  </ng-container>
                                  <ng-template #showTagIcon>
                                    <i class="bi bi-tag"></i>
                                  </ng-template>
                                </button>
                              </span> -->
                                    </td>

                                    <td *ngIf="enabletag === 1">
                                      <span
                                        class="d-flex align-items-start gap-2"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-light btn-sm overflow-hidden text-truncate"
                                          data-bs-toggle="modal"
                                          data-bs-target="#tagsModal"
                                          (click)="allAttribute(e, i)"
                                          [title]="getFullTag(e['tag'])"
                                        >
                                          <ng-container
                                            *ngIf="
                                              getCleanTag(e['tag']) !==
                                                'Add Tags';
                                              else showTagIcon
                                            "
                                          >
                                            {{ getCleanTag(e["tag"]) }}
                                          </ng-container>
                                          <ng-template #showTagIcon>
                                            <i class="bi bi-tag tagbtnicon"></i>
                                          </ng-template>
                                        </button>
                                      </span>
                                    </td>
                                    <td>
                                      <div class="d-flex align-items-center">
                                        <button
                                          mat-stroked-button
                                          color="primary"
                                          class="icon-center icon-clean icon-width ms-1 me-2"
                                          [matTooltip]="
                                            'UsecaseData.USECASE.LIST.ACTIONS.INFO'
                                              | translate
                                          "
                                          (click)="openInfoModal(e)"
                                        >
                                          <mat-icon class="icon-compact"
                                            >info</mat-icon
                                          >
                                        </button>
                                        <button
                                          mat-stroked-button
                                          color="warn"
                                          class="icon-center icon-clean icon-width ms-1"
                                          [matTooltip]="
                                            'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                              | translate
                                          "
                                          (click)="deleteUsecaseData(e['id'])"
                                        >
                                          <mat-icon class="icon-compact"
                                            >delete</mat-icon
                                          >
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          [class.show]="
                            isArchivedlistTabActive && !isTrashTabActive
                          "
                          [class.active]="
                            isArchivedlistTabActive && !isTrashTabActive
                          "
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                        >
                          <div class="table-container mx-2">
                            <div class="table-responsive table-scrollable">
                              <table
                                class="table table-bordered table-sticky-header"
                              >
                                <thead>
                                  <tr>
                                    <th>
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.SERIAL_NO"
                                          | translate
                                      }}
                                    </th>
                                    <th
                                      *ngFor="
                                        let e of attributeList;
                                        let i = index
                                      "
                                      (click)="sortTable(e.code)"
                                    >
                                      {{ getFilterLable(e["label"]) }}
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'ASC'
                                        "
                                        class="fa fa-sort-up ms-1"
                                      ></i>
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'DESC'
                                        "
                                        class="fa fa-sort-down ms-1"
                                      ></i>
                                      <i
                                        *ngIf="sortedField !== e.code"
                                        class="fa fa-sort ms-1"
                                      ></i>
                                    </th>
                                    <th>
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.ACTIONS"
                                          | translate
                                      }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let e of form.archivedlist;
                                      let i = index
                                    "
                                  >
                                    <td class="text-center">
                                      {{ pageIndex(i) }}
                                    </td>
                                    <td
                                      class="text-wrap"
                                      *ngFor="
                                        let at of attributeList;
                                        let i = index
                                      "
                                    >
                                      <span
                                        *ngIf="
                                          at['type'] === 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'doc' &&
                                          at['type'] !== 'location'
                                        "
                                      >
                                        {{ e[at["code"]] | json }}
                                      </span>

                                      <!-- getString se text aur number exclude karo -->
                                      <span
                                        *ngIf="
                                          at['type'] != 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'doc' &&
                                          at['type'] !== 'location' &&
                                          at['type'] !== 'textarea' &&
                                          at['type'] != 'time' &&
                                          at['type'] != 'itime' &&
                                          at['type'] !== 'text' &&
                                          at['type'] !== 'number'
                                        "
                                      >
                                        {{
                                          getString(e[at["code"]], at["type"])
                                        }}
                                      </span>

                                      <span
                                        *ngIf="
                                          at['type'] != 'list' &&
                                          at['type'] != 'object' &&
                                          at['type'] !== 'location' &&
                                          at['type'] === 'file'
                                        "
                                      >
                                        <a
                                          href="{{ getAppDoc(e[at['code']]) }}"
                                          target="_blank"
                                        >
                                          <img
                                            src="{{
                                              getAppDocThumbnail(e[at['code']])
                                            }}"
                                            width="50px"
                                          />
                                        </a>
                                      </span>

                                      <div
                                        *ngIf="at['type'] === 'textarea'"
                                        class="custom-textarea"
                                        [innerHTML]="
                                          getSanitizedHtml(e[at['code']])
                                        "
                                      ></div>

                                      <span *ngIf="at['type'] === 'time'">
                                        {{
                                          at["depAttribute"]
                                            ? getString1(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                            : getString1(
                                                e[at["code"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'itime'">
                                        {{
                                          at["depAttribute"]
                                            ? getStringitime(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                            : getStringitime(
                                                e[at["code"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'location'">
                                        <ng-container
                                          *ngIf="
                                            getLocationObject(
                                              at['depAttribute']
                                                ? e[at['depAttribute']]
                                                : e[at['code']]
                                            ) as loc
                                          "
                                        >
                                          <a
                                            [href]="
                                              'https://www.google.com/maps?q=' +
                                              loc.lat +
                                              ',' +
                                              loc.lng
                                            "
                                            target="_blank"
                                            style="text-decoration: none"
                                          >
                                            {{ loc.lat }},{{ loc.lng }}
                                          </a>
                                        </ng-container>
                                      </span>

                                      <!-- Text / Number with QR/Barcode Support — TD KE ANDAR -->
                                      <span
                                        *ngIf="
                                          at['type'] === 'text' ||
                                          at['type'] === 'number'
                                        "
                                        class="d-block"
                                      >
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'qr' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'qr',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <qrcode
                                                [qrdata]="
                                                  e[at['code']].toString()
                                                "
                                                [width]="50"
                                                [errorCorrectionLevel]="'M'"
                                              ></qrcode>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #2e2e2e;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'bar' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'bar',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <ngx-barcode6
                                                [bc-value]="
                                                  e[at['code']].toString()
                                                "
                                                bc-format="CODE128"
                                                [bc-display-value]="false"
                                                [bc-width]="0.8"
                                                [bc-height]="20"
                                              ></ngx-barcode6>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #363636;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'none' ||
                                            !at['codeType'] ||
                                            !e[at['code']]
                                          "
                                        >
                                          <span
                                            class="text-start d-block"
                                            [title]="e[at['code']]"
                                            >{{
                                              e[at["code"]] | truncate: 40
                                            }}</span
                                          >
                                        </ng-container>
                                      </span>
                                    </td>
                                    <!-- ← TD YAHAN BAND HOGI -->

                                    <td>
                                      <div class="d-flex">
                                        <button
                                          mat-stroked-button
                                          color="primary"
                                          class="icon-width"
                                          [title]="
                                            'UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE'
                                              | translate
                                          "
                                          (click)="retrieve(e['id'])"
                                        >
                                          <mat-icon>archive</mat-icon>
                                          <span class="ms-1">{{
                                            "UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE"
                                              | translate
                                          }}</span>
                                        </button>
                                        <button
                                          mat-stroked-button
                                          color="warn"
                                          class="ms-1 icon-width"
                                          [title]="
                                            'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                              | translate
                                          "
                                          (click)="deleteUsecaseData(e['id'])"
                                        >
                                          <mat-icon class="icon-compact"
                                            >delete</mat-icon
                                          >
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          [class.show]="isTrashTabActive"
                          [class.active]="isTrashTabActive"
                          id="pills-trash"
                          role="tabpanel"
                          aria-labelledby="pills-trash-tab"
                        >
                          <div class="table-container mx-2">
                            <div class="table-responsive table-scrollable">
                              <table
                                class="table table-bordered table-sticky-header"
                              >
                                <thead>
                                  <tr>
                                    <th>
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.SERIAL_NO"
                                          | translate
                                      }}
                                    </th>
                                    <th
                                      *ngFor="
                                        let e of attributeList;
                                        let i = index
                                      "
                                      (click)="sortTable(e.code)"
                                    >
                                      {{ getFilterLable(e["label"]) }}
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'ASC'
                                        "
                                        class="fa fa-sort-up ms-1"
                                      ></i>
                                      <i
                                        *ngIf="
                                          sortedField === e.code &&
                                          sortOrder === 'DESC'
                                        "
                                        class="fa fa-sort-down ms-1"
                                      ></i>
                                      <i
                                        *ngIf="sortedField !== e.code"
                                        class="fa fa-sort ms-1"
                                      ></i>
                                    </th>
                                    <th>
                                      {{
                                        "UsecaseData.USECASE.LIST.TABLE.ACTIONS"
                                          | translate
                                      }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let e of form.trashlist;
                                      let i = index
                                    "
                                  >
                                    <td class="text-center">
                                      {{ pageIndex(i) }}
                                    </td>
                                    <td
                                      class="text-wrap"
                                      *ngFor="
                                        let at of attributeList;
                                        let i = index
                                      "
                                    >
                                      <span
                                        *ngIf="
                                          at['type'] === 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'location'
                                        "
                                      >
                                        {{ e[at["code"]] | json }}
                                      </span>

                                      <span *ngIf="at['type'] === 'location'">
                                        <ng-container
                                          *ngIf="
                                            getLocationObject(
                                              at['depAttribute']
                                                ? e[at['depAttribute']]
                                                : e[at['code']]
                                            ) as loc
                                          "
                                        >
                                          <a
                                            [href]="
                                              'https://www.google.com/maps?q=' +
                                              loc.lat +
                                              ',' +
                                              loc.lng
                                            "
                                            target="_blank"
                                            style="text-decoration: none"
                                          >
                                            {{ loc.lat }},{{ loc.lng }}
                                          </a>
                                        </ng-container>
                                      </span>

                                      <span
                                        *ngIf="
                                          at['type'] != 'object' &&
                                          at['type'] != 'file' &&
                                          at['type'] !== 'location' &&
                                          at['type'] != 'time' &&
                                          at['type'] != 'itime' &&
                                          at['type'] !== 'text' &&
                                          at['type'] !== 'number' &&
                                          at['type'] !== 'textarea'
                                        "
                                      >
                                        {{
                                          getString(e[at["code"]], at["type"])
                                        }}
                                      </span>

                                      <span
                                        *ngIf="
                                          at['type'] != 'list' &&
                                          at['type'] != 'object' &&
                                          at['type'] !== 'file' &&
                                          at['type'] === 'doc' &&
                                          at['type'] !== 'location'
                                        "
                                      >
                                        <a
                                          href="{{ getAppDoc(e[at['code']]) }}"
                                          target="_blank"
                                        >
                                          <img
                                            src="{{
                                              getAppDocThumbnail(e[at['code']])
                                            }}"
                                            width="50px"
                                          />
                                        </a>
                                      </span>

                                      <span *ngIf="at['type'] === 'time'">
                                        {{
                                          at["depAttribute"]
                                            ? getString1(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                            : getString1(
                                                e[at["code"]],
                                                at["type"],
                                                at["timeFormat"]
                                              )
                                        }}
                                      </span>

                                      <span *ngIf="at['type'] === 'itime'">
                                        {{
                                          at["depAttribute"]
                                            ? getStringitime(
                                                e[at["depAttribute"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                            : getStringitime(
                                                e[at["code"]],
                                                at["type"],
                                                at["itimeFormat"]
                                              )
                                        }}
                                      </span>

                                      <div
                                        *ngIf="at['type'] === 'textarea'"
                                        class="custom-textarea"
                                        [innerHTML]="
                                          getSanitizedHtml(e[at['code']])
                                        "
                                      ></div>

                                      <!-- Text / Number with QR/Barcode Support -->
                                      <span
                                        *ngIf="
                                          at['type'] === 'text' ||
                                          at['type'] === 'number'
                                        "
                                        class="d-block"
                                      >
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'qr' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'qr',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <qrcode
                                                [qrdata]="
                                                  e[at['code']].toString()
                                                "
                                                [width]="50"
                                                [errorCorrectionLevel]="'M'"
                                              ></qrcode>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #2e2e2e;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'bar' &&
                                            e[at['code']]
                                          "
                                        >
                                          <a
                                            href="javascript:void(0)"
                                            [title]="e[at['code']]"
                                            (click)="
                                              openCodeInNewTab(
                                                'bar',
                                                e[at['code']].toString()
                                              )
                                            "
                                            class="code-link text-decoration-none"
                                          >
                                            <div
                                              class="d-flex flex-column align-items-center"
                                            >
                                              <ngx-barcode6
                                                [bc-value]="
                                                  e[at['code']].toString()
                                                "
                                                bc-format="CODE128"
                                                [bc-display-value]="false"
                                                [bc-width]="0.8"
                                                [bc-height]="20"
                                              ></ngx-barcode6>
                                              <div
                                                class="text-center mt-1"
                                                style="
                                                  font-size: 11px;
                                                  color: #363636;
                                                "
                                              >
                                                {{
                                                  e[at["code"]] | truncate: 10
                                                }}
                                              </div>
                                            </div>
                                          </a>
                                        </ng-container>
                                        <ng-container
                                          *ngIf="
                                            at['codeType'] === 'none' ||
                                            !at['codeType'] ||
                                            !e[at['code']]
                                          "
                                        >
                                          <span
                                            class="text-start d-block"
                                            [title]="e[at['code']]"
                                            >{{
                                              e[at["code"]] | truncate: 40
                                            }}</span
                                          >
                                        </ng-container>
                                      </span>
                                    </td>

                                    <td>
                                      <div class="d-flex">
                                        <button
                                          mat-stroked-button
                                          color="primary"
                                          class="icon-width"
                                          matTooltip="{{
                                            'UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE'
                                              | translate
                                          }}"
                                          (click)="retrieve(e['id'])"
                                        >
                                          <mat-icon>archive</mat-icon>
                                          {{
                                            "UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE"
                                              | translate
                                          }}
                                        </button>
                                        <button
                                          mat-stroked-button
                                          color="warn"
                                          class="ms-1 icon-width"
                                          matTooltip="{{
                                            'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                              | translate
                                          }}"
                                          (click)="deleteUsecaseData(e['id'])"
                                        >
                                          <mat-icon>delete</mat-icon>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card-content>
                  </div>
                  <app-list-header [$parent]="getSelf()"></app-list-header>
                  <!-- search panel end  -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="usecase-dashboard"
          role="tabpanel"
          aria-labelledby="usecase-dashboard-tab"
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div
                  class="d-flex justify-content-between flex-wrap gap-2 align-item-center mb-3"
                >
                  <div>
                    <h5 class="d-flex align-items-center mb-0">
                      <mat-icon
                        class="text-primary me-2"
                        style="font-size: 24px; width: 24px; height: 24px"
                      >
                        subtitles
                      </mat-icon>

                      <p class="wrap-text mb-0 ms-1">
                        {{ usecaseSchema["name"] }} &gt;
                        {{ "UsecaseData.DASHBOARD.ENTRY" | translate }}
                      </p>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <!-- form  -->
                <div class="card">
                  <div
                    class="card-header d-flex justify-content-between bg-white py-2"
                  >
                    <h5 class="modal-title wrap-text pb-2">
                      {{ usecaseSchema["name"] }}
                    </h5>
                    <button
                      mat-icon-button
                      *ngIf="usecaseSchema['description']"
                      [matTooltip]="usecaseSchema['description']"
                      matTooltipPosition="above"
                      class="small-info-btn"
                    >
                      <mat-icon class="text-secondary">info</mat-icon>
                    </button>
                  </div>

                  <div class="card-body">
                    <p *ngIf="form['error'] == false && form['message']">
                      <app-ncs-alert
                        [message]="form['message']"
                        type="success"
                      />
                    </p>
                    <p *ngIf="form['error'] == true && form['message']">
                      <app-ncs-alert
                        [message]="form['message']"
                        type="danger"
                      />
                    </p>
                    <!-- angular form starts here -->
                    <form
                      class="compact-inputs dropdown-pd-none"
                      #usecaseForm="ngForm"
                    >
                      <div *ngFor="let e of filterAttributes(); let i = index">
                        <!-- Labels for different field types -->
                        <label
                          *ngIf="
                            e['type'] !== 'file' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'boolean' &&
                            e['type'] !== 'location' &&
                            e['type'] !== 'expression'
                          "
                          class="d-block pb-2"
                          style="font-weight: 400"
                        >
                          {{ getFilterLable(e["label"]) }}

                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                            matTooltipClass="custom-tooltip-style"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>

                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <label
                          *ngIf="
                            e['type'] !== 'file' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'location' &&
                            e['type'] !== 'combobox' &&
                            e['type'] === 'boolean'
                          "
                          class="d-block pb-2"
                          style="font-weight: 400"
                        >
                          {{ getFilterLable(e["label"]) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>

                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <label
                          *ngIf="
                            e['type'] !== 'file' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'location' &&
                            e['type'] === 'expression'
                          "
                          class="d-block pb-2"
                          style="font-weight: 400"
                        >
                          {{ getFilterLable(e["label"]) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>
                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <label
                          *ngIf="
                            e['type'] === 'file' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'combobox' &&
                            e['type'] !== 'location'
                          "
                          class="d-block pb-2"
                          style="font-weight: 400"
                        >
                          {{ getFilterLable(e["label"]) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>
                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <label
                          *ngIf="
                            e['type'] !== 'file' &&
                            e['type'] === 'doc' &&
                            e['type'] !== 'combobox' &&
                            e['type'] !== 'location'
                          "
                          class="d-block pb-2"
                          style="font-weight: 400"
                        >
                          {{ getFilterLable(e["label"]) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>
                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <label
                          class="d-block pb-2"
                          style="font-weight: 400"
                          *ngIf="e['type'] === 'location'"
                        >
                          {{ getFilterLable(e.label) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span
                            *ngIf="e.showDescription !== 1"
                            [matTooltip]="getDescription(e)"
                            matTooltipPosition="right"
                          >
                            <mat-icon
                              class="ms-1 text-secondary icon-compact topmove"
                              >info</mat-icon
                            >
                          </span>
                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <mat-form-field
                          appearance="outline"
                          *ngIf="
                            e['refKey'] != 1 &&
                            e['type'] !== 'list' &&
                            e['type'] !== 'combobox' &&
                            e['type'] !== 'file' &&
                            e['type'] !== 'map' &&
                            e['type'] !== 'textarea' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'boolean' &&
                            e['type'] !== 'expression' &&
                            e['type'] !== 'location' &&
                            e['type'] !== 'password' &&
                            e['type'] !== 'date' &&
                            e['type'] !== 'dateandtime' &&
                            e['type'] !== 'idate' &&
                            e['type'] !== 'itime' &&
                            e['type'] !== 'time' &&
                            e['type'] !== 'json'
                          "
                          class="w-100"
                        >
                          <input
                            matInput
                            [type]="getInputType(e.type)"
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (input)="
                              restrictDecimalPlaces(
                                $event,
                                e.label,
                                e?.placeValue
                              )
                            "
                          />
                        </mat-form-field>

                        <!-- Separate mat-form-field for idate (similar to date field) -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'idate'"
                          class="w-100"
                        >
                          <input
                            matInput
                            type="date"
                            #idateInput
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (change)="
                              enforceMaxDate($any($event), e.code, e.type)
                            "
                            [readonly]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                            [min]="
                              e.type === 'idate'
                                ? convertIntoLocalDate(e.minDate)
                                : null
                            "
                            [max]="
                              e.type === 'idate'
                                ? convertIntoLocalDate(e.maxDate)
                                : null
                            "
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="idateInput.showPicker()"
                            aria-label="Open date picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >event</mat-icon
                            >
                          </button>
                        </mat-form-field>

                        <!-- Separate mat-form-field for itime (time input) -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'time'"
                          class="w-100"
                        >
                          <input
                            matInput
                            type="time"
                            #itimeInput
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (change)="
                              enforceMaxDate($any($event), e.code, e.type)
                            "
                            [readonly]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="itimeInput.showPicker()"
                            aria-label="Open time picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >schedule</mat-icon
                            >
                          </button>
                        </mat-form-field>

                        <!-- Separate mat-form-field for itime (time input) -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'itime'"
                          class="w-100"
                        >
                          <input
                            matInput
                            type="time"
                            #itimeInput
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (change)="
                              enforceMaxDate($any($event), e.code, e.type)
                            "
                            [readonly]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="itimeInput.showPicker()"
                            aria-label="Open time picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >schedule</mat-icon
                            >
                          </button>
                        </mat-form-field>

                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'date'"
                          class="w-100"
                        >
                          <input
                            matInput
                            type="date"
                            #dateInput
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (change)="
                              enforceMaxDate($any($event), e.code, e.type)
                            "
                            [readonly]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                            [min]="e.type === 'date' ? e.minDate : null"
                            [max]="e.type === 'date' ? e.maxDate : null"
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="dateInput.showPicker()"
                            aria-label="Open date picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >event</mat-icon
                            >
                          </button>
                        </mat-form-field>

                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'dateandtime'"
                          class="w-100"
                        >
                          <input
                            matInput
                            type="datetime-local"
                            #datetimeInput
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (change)="
                              enforceMaxDate($any($event), e.code, e.type)
                            "
                            [readonly]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                          />

                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="datetimeInput.showPicker()"
                            aria-label="Open date time picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >calendar_month</mat-icon
                            >
                          </button>
                        </mat-form-field>

                        <!-- Password field -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'password'"
                          class="w-100 compact-inputs"
                        >
                          <input
                            matInput
                            [type]="showPassword ? 'text' : 'password'"
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            class="icon-pd-none"
                            (click)="togglePasswordVisibility()"
                            [attr.aria-label]="
                              showPassword ? 'Hide password' : 'Show password'
                            "
                          >
                            <mat-icon class="icon-compact text-secondary">{{
                              showPassword ? "visibility" : "visibility_off"
                            }}</mat-icon>
                          </button>
                        </mat-form-field>

                        <!-- Expression field (disabled) -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="
                            e['refKey'] != 1 &&
                            e['type'] !== 'list' &&
                            e['type'] !== 'combobox' &&
                            e['type'] !== 'file' &&
                            e['type'] !== 'map' &&
                            e['type'] !== 'textarea' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'location' &&
                            e['type'] === 'expression'
                          "
                          class="w-100"
                        >
                          <!-- <mat-label>{{getFilterLable(e.label)}}</mat-label> -->
                          <input
                            matInput
                            [type]="getInputType(e.type)"
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [placeholder]="getFilterLable(e.label)"
                            (input)="
                              restrictDecimalPlaces(
                                $event,
                                e.label,
                                e?.placeValue
                              )
                            "
                            disabled
                          />
                        </mat-form-field>

                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['refKey'] == 1"
                          class="w-100"
                        >
                          <mat-select
                            [ngModel]="
                              form.data[e.code] === undefined
                                ? ''
                                : form.data[e.code]
                            "
                            (ngModelChange)="
                              form.data[e.code] =
                                $event === '' ? undefined : $event
                            "
                            [disabled]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                            [required]="e['required'] == 1"
                            [name]="e.code"
                            (selectionChange)="onChange(e, $event.value)"
                          >
                            <mat-option value="" style="display: none">
                              -- Select {{ getFilterLable(e.label) }} --
                            </mat-option>
                            <ngx-mat-select-search
                              #searchControl
                              [placeholderLabel]="'Search...'"
                              [noEntriesFoundLabel]="'No matches'"
                            >
                            </ngx-mat-select-search>
                            <mat-option
                              *ngFor="
                                let item of getFilteredData(
                                  form.preload?.[e.primaryUsecase] || []
                                )
                              "
                              [value]="item.id"
                              [style.display]="
                                !searchControl.value ||
                                item._val
                                  .toLowerCase()
                                  .includes(searchControl.value.toLowerCase())
                                  ? 'block'
                                  : 'none'
                              "
                            >
                              {{ item._val }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Location Field -->
                        <div *ngIf="e['type'] === 'location'">
                          <div class="d-flex align-items-center flex-wrap">
                            <ng-container
                              *ngIf="
                                form.data[e.code]?.lat != null &&
                                form.data[e.code]?.lng != null
                              "
                            >
                              <mat-form-field
                                appearance="outline"
                                class="me-2 dropdown-pd-none"
                                style="flex: 1"
                              >
                                <mat-label>{{
                                  "UsecaseData.FORM.LATITUDE" | translate
                                }}</mat-label>
                                <input
                                  matInput
                                  type="number"
                                  readonly
                                  [(ngModel)]="form.data[e.code].lat"
                                  [name]="e.code + '_lat'"
                                />
                              </mat-form-field>
                              <mat-form-field
                                appearance="outline"
                                class="me-2 dropdown-pd-none"
                                style="flex: 1"
                              >
                                <mat-label>{{
                                  "UsecaseData.FORM.LONGITUDE" | translate
                                }}</mat-label>
                                <input
                                  matInput
                                  type="number"
                                  readonly
                                  [(ngModel)]="form.data[e.code].lng"
                                  [name]="e.code + '_lng'"
                                />
                              </mat-form-field>
                            </ng-container>

                            <ng-template #emptyInputs>
                              <mat-form-field
                                appearance="outline"
                                class="me-2 dropdown-pd-none"
                                style="flex: 1"
                              >
                                <input
                                  matInput
                                  type="text"
                                  readonly
                                  [value]="
                                    'UsecaseData.LOCATION.NO_LOCATION'
                                      | translate
                                  "
                                  [name]="e.code + '_lat_placeholder'"
                                />
                              </mat-form-field>
                              <mat-form-field
                                appearance="outline"
                                class="me-2 dropdown-pd-none"
                                style="flex: 1"
                              >
                                <input
                                  matInput
                                  type="text"
                                  readonly
                                  [value]="
                                    'UsecaseData.LOCATION.NO_LOCATION'
                                      | translate
                                  "
                                  [name]="e.code + '_lng_placeholder'"
                                />
                              </mat-form-field>
                            </ng-template>
                            <div>
                              <button
                                mat-stroked-button
                                color="warn"
                                [matTooltip]="
                                  'UsecaseData.BUTTONS.SET_LOCATION' | translate
                                "
                                class="me-2 icon-width"
                                (click)="setCurrentLocation(e.code)"
                              >
                                <mat-icon class="icon-compact"
                                  >location_on</mat-icon
                                >
                              </button>

                              <button
                                mat-stroked-button
                                color="primary"
                                [matTooltip]="
                                  'UsecaseData.BUTTONS.VIEW_MAP' | translate
                                "
                                class="me-2 icon-width"
                                (click)="viewOnMap(e.code)"
                              >
                                <mat-icon class="icon-compact">map</mat-icon>
                              </button>

                              <button
                                mat-stroked-button
                                color="warn"
                                [matTooltip]="
                                  'UsecaseData.BUTTONS.CLEAR_LOCATION'
                                    | translate
                                "
                                class="icon-width"
                                (click)="clearLocation(e.code)"
                              >
                                <i
                                  class="fa fa-eraser icon-compact d-inline-block"
                                  style="font-size: 16px !important"
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Boolean field -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'boolean'"
                          class="w-100"
                        >
                          <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                          <mat-select
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                          >
                            <mat-option [value]="undefined" disabled>{{
                              "UsecaseData.SELECT.DEFAULT" | translate
                            }}</mat-option>
                            <mat-option [value]="1">{{
                              "UsecaseData.BOOLEAN.TRUE" | translate
                            }}</mat-option>
                            <mat-option [value]="0">{{
                              "UsecaseData.BOOLEAN.FALSE" | translate
                            }}</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Json field -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'json'"
                          class="w-100"
                        >
                          <textarea
                            matInput
                            [(ngModel)]="form.data[e.code]"
                            [id]="e.code"
                            [name]="e.code"
                            rows="5"
                            class="font-monospace"
                            placeholder='{ "key": "value" }'
                          >
                          </textarea>
                        </mat-form-field>

                        <!-- Textarea field -->
                        <div *ngIf="e['type'] === 'textarea'">
                          <div
                            class="custom-editor-wrapper"
                            *ngIf="e.enableEditor === 1"
                          >
                            <ng-container>
                              <ngx-editor-menu
                                [editor]="editors[e.code]"
                                [toolbar]="toolbar"
                              ></ngx-editor-menu>
                              <ngx-editor
                                [(ngModel)]="form.data[e.code]"
                                [editor]="editors[e.code]"
                                [placeholder]="getFilterLable(e.label)"
                                class="custom-editor"
                              >
                              </ngx-editor>
                            </ng-container>
                          </div>

                          <mat-form-field
                            appearance="outline"
                            *ngIf="e.enableEditor !== 1"
                            class="w-100"
                          >
                            <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                            <textarea
                              matInput
                              [ngModel]="
                                e.enableEditor !== 1
                                  ? removeHTMLTags(form.data[e.code])
                                  : form.data[e.code]
                              "
                              (ngModelChange)="form.data[e.code] = $event"
                              [name]="e.code"
                              [placeholder]="getFilterLable(e.label)"
                            ></textarea>
                          </mat-form-field>
                        </div>

                        <!-- List field -->
                        <!-- List field -->
                        <div *ngIf="e['type'] === 'list'" class="w-100">
                          <div
                            *ngIf="
                              e['listType'] === 'none' ||
                              e['listType'] === '' ||
                              !e['listType']
                            "
                            class="d-flex align-items-center w-100"
                          >
                            <!-- MULTIPLE SELECT -->
                            <mat-form-field
                              appearance="outline"
                              *ngIf="e['multipleSelect'] == 1"
                              class="w-100"
                            >
                              <mat-label>{{
                                getFilterLable(e.label)
                              }}</mat-label>
                              <mat-select
                                [(ngModel)]="form.data[e.code]"
                                [name]="e.code"
                                [panelClass]="'clear-icon-compact-panel'"
                                [required]="e['required'] == 1"
                                [disabled]="
                                  e['readOnly'] ||
                                  (e.allowChangeAfterInitial == 1 &&
                                    form.data['id'] > 0)
                                "
                                multiple
                              >
                                <ngx-mat-select-search
                                  #searchMulti
                                  [placeholderLabel]="'Search...'"
                                  [noEntriesFoundLabel]="'No matches'"
                                >
                                </ngx-mat-select-search>
                                <mat-option
                                  *ngFor="let option of e['values']"
                                  [value]="option"
                                  [style.display]="
                                    !searchMulti.value ||
                                    option
                                      .toLowerCase()
                                      .includes(searchMulti.value.toLowerCase())
                                      ? 'block'
                                      : 'none'
                                  "
                                >
                                  {{ option }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                            <!-- SINGLE SELECT -->
                            <mat-form-field
                              appearance="outline"
                              *ngIf="e['multipleSelect'] != 1"
                              class="w-100"
                            >
                              <mat-select
                                [ngModel]="
                                  form.data[e.code] === undefined
                                    ? ''
                                    : form.data[e.code]
                                "
                                (ngModelChange)="
                                  form.data[e.code] =
                                    $event === '' ? undefined : $event
                                "
                                [name]="e.code"
                                [panelClass]="'clear-icon-compact-panel'"
                                [required]="e['required'] == 1"
                                [disabled]="
                                  e['readOnly'] ||
                                  (e.allowChangeAfterInitial == 1 &&
                                    form.data['id'] > 0)
                                "
                              >
                                <mat-option value="" style="display: none">
                                  -- Select {{ getFilterLable(e.label) }} --
                                </mat-option>
                                <ngx-mat-select-search
                                  #searchSingle
                                  [placeholderLabel]="'Search...'"
                                  [noEntriesFoundLabel]="'No matches'"
                                >
                                </ngx-mat-select-search>
                                <mat-option
                                  *ngFor="let c of e['values']"
                                  [value]="c"
                                  [style.display]="
                                    !searchSingle.value ||
                                    c
                                      .toLowerCase()
                                      .includes(
                                        searchSingle.value.toLowerCase()
                                      )
                                      ? 'block'
                                      : 'none'
                                  "
                                >
                                  {{ c }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <!-- RADIO -->
                          <div
                            *ngIf="e['listType'] === 'radio'"
                            class="d-flex align-items-center w-100"
                          >
                            <mat-radio-group
                              [(ngModel)]="form.data[e.code]"
                              [name]="e.code"
                              [disabled]="
                                e['readOnly'] ||
                                (e.allowChangeAfterInitial == 1 &&
                                  form.data['id'] > 0)
                              "
                              class="d-flex"
                              [class.flex-column]="
                                e['showVertical'] === 'vertical'
                              "
                              [class.flex-row]="
                                e['showVertical'] === 'horizontal' ||
                                !e['showVertical']
                              "
                            >
                              <mat-radio-button
                                *ngFor="let option of e['values']"
                                color="primary"
                                [value]="option"
                                class="me-3"
                                (change)="onRadioChange(e, option)"
                              >
                                {{ option }}
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>
                        </div>

                        <!-- File upload field -->
                        <div *ngIf="e['type'] === 'file'">
                          <div class="d-flex align-items-center">
                            <mat-form-field appearance="outline" class="w-100">
                              <input
                                matInput
                                readonly
                                placeholder="Choose file here.."
                                [value]="fileInput.files?.[0]?.name || ''"
                                (click)="fileInput.click()"
                                style="cursor: pointer"
                              />
                              <button
                                mat-icon-button
                                matSuffix
                                (click)="fileInput.click()"
                                type="button"
                                class="icon-pd-none"
                              >
                                <mat-icon class="icon-compact"
                                  >attach_file</mat-icon
                                >
                              </button>
                              <input
                                type="file"
                                #fileInput
                                hidden
                                [id]="'entryform.data[' + e.code + ']'"
                                [name]="'entryform.data[' + e.code + ']'"
                                accept="image/*"
                                (change)="openCropperModal($event, e.code)"
                              />
                            </mat-form-field>
                          </div>
                          <div *ngIf="fileErrors[e.code]" class="text-danger">
                            {{
                              "UsecaseData.ERRORS.INVALID_FILE_TYPE" | translate
                            }}
                          </div>
                          <div *ngIf="imageSizes[e.code]" class="text-danger">
                            {{
                              "UsecaseData.ERRORS.FILE_SIZE_LIMIT"
                                | translate: { size: e.size || 1 }
                            }}
                          </div>
                        </div>

                        <!-- Image Preview -->
                        <div class="my-2" *ngIf="e['type'] === 'file'">
                          <div
                            *ngIf="!fileErrors[e.code] && !imageSizes[e.code]"
                          >
                            <a
                              href="{{ getAppDoc(form.data[e.code]) }}"
                              target="_blank"
                            >
                              <img
                                [src]="
                                  imagePreviews[e.code]
                                    ? imagePreviews[e.code]
                                    : getAppDocThumbnail(form.data[e.code])
                                "
                                [alt]="'UsecaseData.IMAGE.PREVIEW' | translate"
                                class="img-thumbnail"
                                style="width: 200px"
                              />
                            </a>
                          </div>
                        </div>

                        <!-- Document upload field -->
                        <div *ngIf="e['type'] === 'doc'">
                          <div class="d-flex align-items-center">
                            <mat-form-field appearance="outline" class="w-100">
                              <input
                                matInput
                                readonly
                                placeholder="Choose file here.."
                                [value]="filedoc.files?.[0]?.name || ''"
                                (click)="filedoc.click()"
                                style="cursor: pointer"
                              />
                              <button
                                mat-icon-button
                                matSuffix
                                (click)="filedoc.click()"
                                class="icon-pd-none"
                                type="button"
                              >
                                <mat-icon>attach_file</mat-icon>
                              </button>
                              <input
                                type="file"
                                #filedoc
                                hidden
                                [id]="'entryform.data[' + e.code + ']'"
                                [name]="'entryform.data[' + e.code + ']'"
                                (change)="
                                  filedoc.files &&
                                    onFileChanged($event, e, form.data[e.code])
                                "
                              />
                            </mat-form-field>
                          </div>
                          <div *ngIf="docSizes[e.code]" class="text-danger">
                            {{
                              "UsecaseData.ERRORS.FILE_SIZE_LIMIT"
                                | translate: { size: e.size || 1 }
                            }}
                          </div>
                          <div
                            *ngIf="docFileErrors[e.code]"
                            class="text-danger"
                          >
                            {{
                              "UsecaseData.ERRORS.INVALID_DOC_TYPE" | translate
                            }}
                          </div>
                        </div>

                        <!-- Document Preview -->
                        <div class="my-2" *ngIf="e['type'] === 'doc'">
                          <a
                            href="{{ getAppDoc(form.data[e.code]) }}"
                            target="_blank"
                          >
                            <img
                              [src]="
                                imagePreview == null
                                  ? getAppDocThumbnail(form.data[e.code])
                                  : imagePreview
                              "
                              [alt]="'UsecaseData.IMAGE.PREVIEW' | translate"
                              class="img-thumbnail"
                              style="width: 200px; height: 150px"
                            />
                          </a>
                        </div>

                        <!-- Map field -->
                        <mat-form-field
                          appearance="outline"
                          *ngIf="e['type'] === 'map'"
                          class="w-100"
                        >
                          <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                          <mat-select
                            [(ngModel)]="form.data[e.code]"
                            [name]="e.code"
                            [required]="e['required'] == 1"
                            [disabled]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                          >
                            <mat-option [value]="undefined" disabled
                              >{{ "UsecaseData.SELECT.DEFAULT" | translate }}
                              {{ e.code }}</mat-option
                            >
                            <mat-option
                              *ngFor="let c of e['values']"
                              [value]="c.key + ' - ' + c.value"
                            >
                              {{ c.key }} - {{ c.value }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Combobox component -->
                        <app-combobox
                          *ngIf="e['type'] === 'combobox'"
                          [e]="e"
                          [entryData]="form.data[e.code]"
                          (valueChange)="form.data[e.code] = $event"
                          [readonly]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              form.data['id'] > 0)
                          "
                          [checkExpression]="checkExpression"
                          [id]="form.data['id']"
                        >
                        </app-combobox>
                        <p class="form-text text-danger pt-0 mt-0 pb-2 ms-2">
                          {{ getInputError(e.code) }}
                        </p>
                      </div>
                    </form>
                    <!-- Add datepickers at the bottom of the form (outside the loop) -->
                    <mat-datepicker #datePicker></mat-datepicker>
                    <mat-datepicker #datetimePicker></mat-datepicker>
                    <!-- angular  form end -->
                  </div>
                  <div class="card-footer bg-white">
                    <div class="pt-2">
                      <button
                        mat-stroked-button
                        color="primary"
                        [title]="'UsecaseData.BUTTONS.SAVE' | translate"
                        [disabled]="!usecaseForm.valid"
                        (click)="saveUsecaseData()"
                      >
                        <mat-icon> save</mat-icon>
                        {{ "UsecaseData.BUTTONS.SAVE" | translate }}
                      </button>

                      <button
                        mat-stroked-button
                        color="primary"
                        class="ms-2"
                        [title]="'UsecaseData.BUTTONS.ADD' | translate"
                        (click)="resetForm(); setDefaultvalue()"
                      >
                        <mat-icon>add</mat-icon>
                        {{ "UsecaseData.BUTTONS.ADD" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-12">
                <div class="card">
                  <div
                    *ngIf="
                      usecaseSchema?.commentEnabled == 1 &&
                      form['data']['id'] > 0
                    "
                  >
                    <div class="card-header p-3 bg-white">
                      <div
                        class="card-title m-0 d-flex align-items-center justify-content-between"
                      >
                        <h6 class="fs-6 mb-0 d-inline-block">
                          {{ "UsecaseData.COMMENTS.TITLE" | translate }}
                        </h6>
                        <button
                          mat-stroked-button
                          color="primary"
                          class="icon-width ms-2"
                          data-bs-target="#commentModel"
                          data-bs-toggle="modal"
                        >
                          <mat-icon class="icon-compact">add</mat-icon>
                          <span>Comment</span>
                        </button>
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="table-container">
                        <div class="table-responsive">
                          <div style="max-height: 400px; overflow-y: auto">
                            <table class="table table-bordered table-hover">
                              <thead>
                                <tr>
                                  <th class="text-center" style="width: 5%">
                                    #
                                  </th>
                                  <th style="width: 60%">Comment</th>
                                  <th style="width: 15%">User & Date</th>
                                  <th class="text-center" style="width: 20%">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="let e of commentList; let i = index"
                                  class="align-middle border-bottom"
                                >
                                  <td
                                    class="py-2 px-2 text-center"
                                    style="font-size: 0.85rem; color: #555"
                                  >
                                    {{ pageIndex(i) }}.
                                  </td>

                                  <td
                                    class="py-2 px-3 text-start"
                                    style="font-size: 0.85rem; color: #555"
                                  >
                                    {{ e.comment }}
                                  </td>

                                  <td class="py-2 px-3 text-end">
                                    <div
                                      class="d-flex align-items-center gap-2 justify-content-end"
                                    >
                                      <div
                                        class="notify bg-light-primary text-primary rounded-circle d-flex align-items-center justify-content-center"
                                        style="
                                          width: 40px;
                                          height: 40px;
                                          font-size: 16px;
                                          font-weight: 600;
                                          border: 1px solid #ddd;
                                        "
                                      >
                                        <span [title]="e.userFirstname">{{
                                          getInitials(e.userFirstname)
                                        }}</span>
                                      </div>
                                      <span
                                        class="text-muted"
                                        style="
                                          white-space: nowrap;
                                          font-size: 0.85rem;
                                          color: #666;
                                        "
                                      >
                                        {{
                                          e.createdDatetime | date: "MMM d, y"
                                        }}
                                      </span>
                                    </div>
                                  </td>

                                  <td class="py-2 px-3 text-end">
                                    <div
                                      class="d-flex gap-2 justify-content-end"
                                    >
                                      <button
                                        mat-stroked-button
                                        color="primary"
                                        class="icon-width"
                                        [title]="
                                          'UsecaseData.BUTTONS.COMMENT_INFO'
                                            | translate
                                        "
                                        data-bs-toggle="modal"
                                        data-bs-target="#appCommentInfo"
                                        (click)="appCommentInfo = e"
                                      >
                                        <mat-icon class="icon-compact"
                                          >info</mat-icon
                                        >
                                      </button>

                                      <button
                                        mat-stroked-button
                                        color="primary"
                                        class="icon-width"
                                        [title]="
                                          'UsecaseData.BUTTONS.EDIT' | translate
                                        "
                                        data-bs-toggle="modal"
                                        data-bs-target="#commentModel"
                                        (click)="getComment(e.id)"
                                      >
                                        <mat-icon class="icon-compact"
                                          >edit</mat-icon
                                        >
                                      </button>

                                      <button
                                        mat-stroked-button
                                        color="warn"
                                        class="icon-width"
                                        [title]="
                                          'UsecaseData.BUTTONS.DELETE'
                                            | translate
                                        "
                                        (click)="deleteComment(e.id)"
                                      >
                                        <mat-icon class="icon-compact"
                                          >delete</mat-icon
                                        >
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-12">
                <!-- Attachment Section -->
                <div class="row">
                  <div
                    class="col-12"
                    *ngIf="
                      usecaseSchema?.attachmentEnabled == 1 &&
                      form['data']['id'] > 0
                    "
                  >
                    <div class="card">
                      <div class="card-header p-3 bg-white">
                        <div
                          class="card-title m-0 d-flex align-items-center justify-content-between"
                        >
                          <h6 class="fs-6 d-inline-block mb-0">
                            {{ "UsecaseData.ATTACHMENTS.TITLE" | translate }}
                          </h6>
                          <button
                            mat-stroked-button
                            color="primary"
                            class="icon-width ms-2"
                            data-bs-toggle="modal"
                            data-bs-target="#attachmentModel"
                          >
                            <mat-icon class="icon-compact">add</mat-icon>
                            <span>Attachment</span>
                          </button>
                        </div>
                      </div>

                      <div class="card-body">
                        <div class="table-container">
                          <div
                            class="table-responsive table-bordered table-hover"
                          >
                            <div style="max-height: 550px; overflow-y: auto">
                              <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th class="text-center" style="width: 5%">
                                      #
                                    </th>
                                    <th class="text-center" style="width: 15%">
                                      Preview
                                    </th>
                                    <th class="text-start" style="width: 40%">
                                      Description
                                    </th>
                                    <th class="text-start" style="width: 20%">
                                      User & Date
                                    </th>
                                    <th class="text-center" style="width: 20%">
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let e of attachmentList;
                                      let i = index
                                    "
                                    class="border-bottom"
                                  >
                                    <td
                                      class="py-3 px-3 text-center"
                                      style="font-size: 0.85rem; color: #555"
                                    >
                                      {{ pageIndex(i) }}.
                                    </td>

                                    <td
                                      class="d-flex align-items-center justify-content-center"
                                      style="font-size: 0.85rem; color: #555"
                                    >
                                      <a
                                        href="{{ getAppDoc(e.attachment) }}"
                                        target="_blank"
                                      >
                                        <div class="image-preview">
                                          <img
                                            src="{{
                                              getAppDocThumbnail(e.attachment)
                                            }}"
                                            class="img-fluid rounded shadow-sm"
                                            [alt]="
                                              'UsecaseData.IMAGE.PREVIEW'
                                                | translate
                                            "
                                          />
                                        </div>
                                      </a>
                                    </td>

                                    <td
                                      class="py-2 px-3 text-start"
                                      [title]="e.description"
                                      style="
                                        font-size: 0.85rem;
                                        color: #555;
                                        white-space: normal;
                                        word-wrap: break-word;
                                        overflow-wrap: break-word;
                                        cursor: pointer;
                                      "
                                    >
                                      <div
                                        class="d-flex align-items-center justify-content-start gap-2"
                                      >
                                        {{ e.description | truncate: 80 }}
                                      </div>
                                    </td>

                                    <td class="py-2 px-3 text-end">
                                      <div
                                        class="d-flex align-items-center justify-content-end gap-2"
                                      >
                                        <div
                                          class="notify bg-light-primary text-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                          style="
                                            width: 40px;
                                            height: 40px;
                                            font-size: 16px;
                                            font-weight: 600;
                                            border: 1px solid #ddd;
                                          "
                                        >
                                          <span [title]="e.userFirstname">{{
                                            getInitials(e.userFirstname)
                                          }}</span>
                                        </div>
                                        <span class="text-muted d-block">
                                          <span
                                            style="
                                              white-space: nowrap;
                                              font-size: 0.85rem;
                                            "
                                          >
                                            {{
                                              e.createdDatetime
                                                | date
                                                  : "MMM d,
                                            y"
                                            }}
                                          </span>
                                        </span>
                                      </div>
                                    </td>

                                    <td class="py-2 px-3 text-center">
                                      <div class="d-flex gap-2">
                                        <button
                                          mat-stroked-button
                                          color="primary"
                                          class="icon-width"
                                          [title]="
                                            'UsecaseData.BUTTONS.ATTACHMENT_INFO'
                                              | translate
                                          "
                                          data-bs-toggle="modal"
                                          data-bs-target="#appAttachmentInfo"
                                          (click)="appAttachmentInfo = e"
                                        >
                                          <mat-icon class="icon-compact"
                                            >info</mat-icon
                                          >
                                        </button>

                                        <button
                                          mat-stroked-button
                                          color="primary"
                                          class="icon-width"
                                          [title]="
                                            'UsecaseData.BUTTONS.EDIT'
                                              | translate
                                          "
                                          data-bs-toggle="modal"
                                          data-bs-target="#attachmentModel"
                                          (click)="getattachment(e.id)"
                                        >
                                          <mat-icon class="icon-compact"
                                            >edit</mat-icon
                                          >
                                        </button>

                                        <button
                                          mat-stroked-button
                                          color="warn"
                                          class="icon-width"
                                          [title]="
                                            'UsecaseData.BUTTONS.DELETE'
                                              | translate
                                          "
                                          (click)="deleteattachment(e.id)"
                                        >
                                          <mat-icon class="icon-compact"
                                            >delete</mat-icon
                                          >
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="usecase-chart"
            role="tabpanel"
            aria-labelledby="usecase-chart-tab"
          >
            <app-usecase-chart
              *ngIf="activetab == 'usecase-chart-tab'"
              [usecaseId]="usecaseId"
            ></app-usecase-chart>
          </div>

          <div
            class="tab-pane fade"
            id="usecase-chart-custom"
            role="tabpanel"
            aria-labelledby="usecase-chart-cutom-tab"
          >
            <app-usecase-chart
              *ngIf="activetab == 'usecase-chart-custom-tab'"
              [usecaseId]="usecaseId"
              [custom]="true"
            ></app-usecase-chart>
          </div>

          <div
            class="tab-pane fade"
            id="usecase-pivot"
            role="tabpanel"
            aria-labelledby="usecase-pivot-cutom-tab"
          >
            <!-- pivot  -->
            <app-usecase-pivot
              *ngIf="activetab == 'usecase-pivot-tab'"
              [usecaseId]="usecaseId"
            ></app-usecase-pivot>
          </div>

          <div
            class="tab-pane fade"
            id="usecase-help"
            role="tabpanel"
            aria-labelledby="usecase-help-tab"
          >
            <div *ngIf="activetab == 'usecase-help-tab'" class="col-11">
              <div class="row">
                <div class="col col-md-12">
                  <h5>
                    <i
                      class="fa fa-info-circle text-primary"
                      aria-hidden="true"
                    ></i>
                    {{ usecaseSchema["name"] }} > Info
                  </h5>
                </div>
                <div class="col col-md-12 mt-3">
                  <div class="card">
                    <div class="card-header">
                      <p class="text-muted">
                        {{ usecaseSchema["description"] }}
                      </p>
                    </div>

                    <div class="card-body">
                      <div *ngFor="let e of attributeList; let i = index">
                        <ng-container>
                          <h6>{{ e.label }}</h6>
                          <p>{{ e.description }}</p>
                        </ng-container>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="usecase-task"
            role="tabpanel"
            aria-labelledby="usecase-task-tab"
          >
            <!-- task  -->
          </div>

          <div
            class="tab-pane fade"
            id="usecase-new"
            role="tabpanel"
            aria-labelledby="usecase-new-tab"
          >
            <!-- new  -->
          </div>

          <div
            class="tab-pane fade"
            id="usecase-settings"
            role="tabpanel"
            aria-labelledby="usecase-settings-tab"
          >
            <!-- settings  -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Modal -->
  <div
    class="modal fade"
    id="infoModal"
    tabindex="-1"
    aria-labelledby="infoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Info</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'UsecaseData.BUTTONS.CLOSE' | translate"
          ></button>
        </div>
        <div class="modal-body">
          <div [innerHTML]="tooltipContent"></div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
          >
            <mat-icon class="me-1">close</mat-icon>
            {{ "UsecaseData.BUTTONS.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--Comment Modal -->
  <div
    class="modal fade"
    id="commentModel"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="commentModelLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="commentModelLabel">
            {{ "UsecaseData.MODAL.COMMENT.TITLE" | translate }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'UsecaseData.BUTTONS.CLOSE' | translate"
            (click)="resetcommentForm()"
          ></button>
        </div>
        <div class="modal-body">
          <p *ngIf="sform['error'] == false && sform['message']">
            <app-ncs-alert [message]="sform['message']" type="success" />
          </p>
          <p *ngIf="sform['error'] == true && sform['message']">
            <app-ncs-alert [message]="sform['message']" type="danger" />
          </p>
          <div
            class="mb-3 compact-inputs dropdown-pd-none ngvalid-borderLeft-none"
          >
            <mat-form-field appearance="outline" class="w-100 red-border">
              <textarea
                matInput
                required
                name="comment"
                id="comment"
                rows="3"
                [(ngModel)]="commentform.data['comment']"
                [placeholder]="
                  'UsecaseData.MODAL.COMMENT.PLACEHOLDER' | translate
                "
              >
              </textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            (click)="resetcommentForm()"
            data-bs-dismiss="modal"
            class="me-2"
          >
            <mat-icon class="me-1">close</mat-icon>
            {{ "UsecaseData.BUTTONS.CLOSE" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="addPageComment()"
            [disabled]="!commentform.data['comment']"
          >
            <mat-icon class="me-1">save</mat-icon>
            {{ "UsecaseData.BUTTONS.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--Attachment Modal -->
  <div
    class="modal fade"
    id="attachmentModel"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="attachmentModelLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="attachmentModelLabel">
            {{ "UsecaseData.MODAL.ATTACHMENT.TITLE" | translate }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'BUTTONS.CLOSE' | translate"
            (click)="resetattachmentForm()"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="mb-3 compact-inputs dropdown-pd-none">
              <label
                class="form-label mat-subtitle-2 d-block mb-1"
                for="description"
              >
                {{ "UsecaseData.FORM.DESCRIPTION" | translate }}
              </label>
              <mat-form-field appearance="outline" class="w-100">
                <textarea
                  matInput
                  name="description"
                  id="description"
                  rows="3"
                  [(ngModel)]="attachmentform.data['description']"
                  [placeholder]="
                    'MODAL.ATTACHMENT.DESCRIPTION_PLACEHOLDER' | translate
                  "
                >
                </textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="mb-3">
            <div class="mb-3 compact-inputs dropdown-pd-none">
              <label
                class="form-label mat-subtitle-2 d-block mb-1"
                for="attachment"
              >
                {{
                  "UsecaseData.MODAL.ATTACHMENT.ATTACHMENT_LABEL" | translate
                }}
                <span class="text-danger">*</span>
              </label>

              <mat-form-field appearance="outline" class="w-100 compact-inputs">
                <div class="d-flex align-items-center">
                  <input
                    matInput
                    readonly
                    placeholder="attach a file here.."
                    [value]="
                      fileAttechment.files && fileAttechment.files[0]
                        ? fileAttechment.files[0].name
                        : ''
                    "
                    (click)="fileAttechment.click()"
                    style="cursor: pointer"
                    required
                  />

                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    class="icon-pd-none"
                    (click)="fileAttechment.click()"
                  >
                    <mat-icon class="icon-compact" style="font-size: 8px"
                      >attach_file</mat-icon
                    >
                  </button>

                  <input
                    type="file"
                    #fileAttechment
                    id="attachment"
                    name="attachment"
                    style="display: none"
                    [(ngModel)]="attachmentform.data['attachment']"
                    (change)="
                      fileAttechment.files && onAttachmentformChanged($event)
                    "
                    required
                  />
                </div>
              </mat-form-field>
            </div>
          </div>
          <div class="mb-4">
            <label class="form-label-custom">
              {{ "UsecaseData.MODAL.ATTACHMENT.PREVIEW" | translate }}
            </label>
            <mat-card appearance="outlined" class="attachment-preview-card">
              <img
                [src]="
                  imageAttachmentPreview == null
                    ? getAppDocThumbnail(attachmentform.data['attachment'])
                    : imageAttachmentPreview
                "
                [alt]="'UsecaseData.MODAL.ATTACHMENT.PREVIEW_ALT' | translate"
                class="attachment-preview-img"
              />
            </mat-card>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            (click)="resetattachmentForm()"
            data-bs-dismiss="modal"
          >
            <mat-icon>close</mat-icon>
            {{ "UsecaseData.BUTTONS.CLOSE" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            type="button"
            class="ms-2"
            [disabled]="
              attachmentform.data['attachment'] == null &&
              imageAttachmentPreview == null
            "
            (click)="saveAttachment()"
          >
            <mat-icon>save</mat-icon>
            {{ "UsecaseData.BUTTONS.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--Attachment Info Modal -->
  <div
    class="modal fade"
    id="appAttachmentInfo"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i
              class="bi bi-info-circle fs-4"
              style="color: #4c5258; font-size: 20px; margin-right: 8px"
            ></i>
            {{ "UsecaseData.MODAL.ATTACHMENT_INFO.TITLE" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th scope="col">
                      {{ "UsecaseData.TABLE.KEY" | translate }}
                    </th>
                    <th scope="col">
                      {{ "UsecaseData.TABLE.VALUE" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.ORGANIZATION"
                          | translate
                      }}
                    </td>
                    <td>{{ appAttachmentInfo?.["orgName"] }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.VERSION" | translate
                      }}
                    </td>
                    <td>{{ appAttachmentInfo?.version }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.CREATED_BY"
                          | translate
                      }}
                    </td>
                    <td>{{ appAttachmentInfo?.createdBy }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.CREATED_DATE"
                          | translate
                      }}
                    </td>
                    <td>
                      {{
                        appAttachmentInfo?.createdDatetime
                          | date
                            : "MMM d, y,
                      h:mm:ss a"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.MODIFIED_BY"
                          | translate
                      }}
                    </td>
                    <td>{{ appAttachmentInfo?.modifiedBy }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.ATTACHMENT_INFO.MODIFIED_DATE"
                          | translate
                      }}
                    </td>
                    <td>
                      {{
                        appAttachmentInfo?.modifiedDatetime
                          | date
                            : "MMM d, y,
                      h:mm:ss a"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
            [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          >
            <mat-icon class="me-1">close</mat-icon>
            <span>Close</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--Comment Info Modal -->
  <div class="modal fade" id="appCommentInfo" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i
              class="bi bi-info-circle fs-4"
              style="color: #4c5258; font-size: 20px; margin-right: 8px"
            ></i>
            {{ "UsecaseData.MODAL.COMMENT_INFO.TITLE" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th scope="col">
                      {{ "UsecaseData.TABLE.KEY" | translate }}
                    </th>
                    <th scope="col">
                      {{ "UsecaseData.TABLE.VALUE" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.COMMENT_INFO.ORGANIZATION"
                          | translate
                      }}
                    </td>
                    <td>{{ appCommentInfo?.["orgName"] }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{ "UsecaseData.MODAL.COMMENT_INFO.VERSION" | translate }}
                    </td>
                    <td>{{ appCommentInfo?.version }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.COMMENT_INFO.CREATED_BY" | translate
                      }}
                    </td>
                    <td>{{ appCommentInfo?.createdBy }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.COMMENT_INFO.CREATED_DATE"
                          | translate
                      }}
                    </td>
                    <td>
                      {{
                        appCommentInfo?.createdDatetime
                          | date
                            : "MMM d, y,
                      h:mm:ss a"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.COMMENT_INFO.MODIFIED_BY" | translate
                      }}
                    </td>
                    <td>{{ appCommentInfo?.modifiedBy }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{
                        "UsecaseData.MODAL.COMMENT_INFO.MODIFIED_DATE"
                          | translate
                      }}
                    </td>
                    <td>
                      {{
                        appCommentInfo?.modifiedDatetime
                          | date
                            : "MMM d, y,
                      h:mm:ss a"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
            [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          >
            <mat-icon class="me-1">close</mat-icon>
            {{ "BUTTONS.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Cropper Modal -->
  <div
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    id="imageModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Crop Image</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            (click)="cancelCrop()"
          ></button>
        </div>

        <!-- Buttons Row -->
        <!-- <div class="button-row mb-3 mt-3 ms-3" *ngIf="showCropper">
                    <button (click)="zoomIn()" [class.enabled]="transform.flipV"
                        class="btn btn-sm btn-outline-primary me-2" [title]="'PROFILE.ZOOM_IN' | translate">
                    <i class="fadeIn animated bx bx-zoom-in"></i>
                </button>
                <button (click)="zoomOut()" [class.enabled]="transform.flipV"
                    class="btn btn-sm btn-outline-primary me-1" [title]="'PROFILE.ZOOM_OUT' | translate">
                    <i class="fadeIn animated bx bx-zoom-out"></i>
                </button>
                <button (click)="rotateRight()" [class.enabled]="transform.flipV"
                    class="btn btn-sm btn-outline-primary me-1" [title]="'PROFILE.ROTATE_RIGHT' | translate">
                    <i class="fadeIn animated bx bx-rotate-right"></i>
                </button>
                <button (click)="rotateLeft()" [class.enabled]="transform.flipV"
                    class="btn btn-sm btn-outline-primary me-1" [title]="'PROFILE.ROTATE_LEFT' | translate">
                    <i class="fadeIn animated bx bx-rotate-left"></i>
                </button>
                <button (click)="flipHorizontal()" [class.enabled]="transform.flipH"
                    class="btn btn-sm btn-outline-primary me-1" [title]="'PROFILE.FLIP_HORIZONTAL' | translate">
                    {{ 'PROFILE.FLIP_HORIZONTAL' | translate }}
                </button>
                <button (click)="flipVertical()" [class.enabled]="transform.flipV"
                    class="btn btn-sm btn-outline-primary me-1" [title]="'PROFILE.FLIP_VERTICAL' | translate">
                    {{ 'PROFILE.FLIP_VERTICAL' | translate }}
                </button>
                </div> -->
        <div class="button-row mb-3 mt-3 ms-3" *ngIf="showCropper">
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomIn()"
            [class.enabled]="transform.flipV"
            class="me-2"
            [title]="'PROFILE.ZOOM_IN' | translate"
          >
            <mat-icon class="me-1">zoom_in</mat-icon>
            {{ "PROFILE.ZOOM_IN" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="zoomOut()"
            [class.enabled]="transform.flipV"
            class="me-1"
            [title]="'PROFILE.ZOOM_OUT' | translate"
          >
            <mat-icon class="me-1">zoom_out</mat-icon>
            {{ "PROFILE.ZOOM_OUT" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="rotateRight()"
            [class.enabled]="transform.flipV"
            class="me-1"
            [title]="'PROFILE.ROTATE_RIGHT' | translate"
          >
            <mat-icon class="me-1">rotate_right</mat-icon>
            {{ "PROFILE.ROTATE_RIGHT" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="rotateLeft()"
            [class.enabled]="transform.flipV"
            class="me-1"
            [title]="'PROFILE.ROTATE_LEFT' | translate"
          >
            <mat-icon class="me-1">rotate_left</mat-icon>
            {{ "PROFILE.ROTATE_LEFT" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="flipHorizontal()"
            [class.enabled]="transform.flipH"
            class="me-1"
            [title]="'PROFILE.FLIP_HORIZONTAL' | translate"
          >
            <mat-icon class="me-1">flip</mat-icon>
            {{ "PROFILE.FLIP_HORIZONTAL" | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="flipVertical()"
            [class.enabled]="transform.flipV"
            class="me-1"
            [title]="'PROFILE.FLIP_VERTICAL' | translate"
          >
            <mat-icon class="me-1">flip</mat-icon>
            {{ "PROFILE.FLIP_VERTICAL" | translate }}
          </button>
        </div>

        <div class="modal-body">
          <div class="w-100 d-flex justify-content-center">
            <div class="cropper-wrapper d-flex justify-content-center">
              <image-cropper
                [disabled]="disabled"
                [alignImage]="alignImage"
                [roundCropper]="roundCropper"
                [hidden]="hidden"
                [imageChangedEvent]="imageChangedEvent"
                [hideResizeSquares]="hideResizeSquares"
                [maintainAspectRatio]="false"
                [canvasRotation]="canvasRotation"
                [containWithinAspectRatio]="false"
                [(transform)]="transform"
                [aspectRatio]="aspectRatio"
                format="png"
                [cropperStaticWidth]="cropperStaticWidth"
                [cropperStaticHeight]="cropperStaticHeight"
                [cropperMinWidth]="cropperMinWidth"
                [cropperMinHeight]="cropperMinHeight"
                [cropperMaxWidth]="cropperMaxWidth"
                [cropperMaxHeight]="cropperMaxHeight"
                [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
                [onlyScaleDown]="true"
                [style.width.%]="100"
                [style.height.%]="100"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (cropperReady)="cropperReady($event)"
                (loadImageFailed)="loadImageFailed()"
              >
              </image-cropper>
            </div>
          </div>

          <div *ngIf="croppedImage" class="mt-3">
            <h6 class="fw-bold">Preview</h6>
            <div class="text-center">
              <img
                [src]="croppedImage"
                alt="Cropped Preview"
                class="img-thumbnail"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            mat-stroked-button
            color="primary"
            class="ms-2"
            [disabled]="!croppedImage"
            (click)="saveCroppedImage()"
            data-bs-dismiss="modal"
          >
            <mat-icon class="me-1">save</mat-icon>
            {{ "COMMON.SAVE" | translate }}
          </button>
          <button
            mat-stroked-button
            color="warn"
            class="ms-2"
            data-bs-dismiss="modal"
            (click)="cancelCrop()"
          >
            <mat-icon class="me-1">close</mat-icon>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Upload Summary Modal - Theme Matched -->
<div
  class="modal fade"
  id="uploadSummaryModal"
  tabindex="-1"
  aria-labelledby="uploadSummaryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h6 modal-title" id="uploadSummaryModalLabel">
          {{
            uploadResult.errorRows === 0
              ? "Upload Completed Successfully"
              : "Upload Completed"
          }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="upload-summary-container ms-3">
          <div class="table-responsive">
            <table class="table table-sm align-middle table-bordered mb-0">
              <tbody>
                <tr>
                  <th style="width: 70%" class="fw-normal">Total Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.totalRows }}
                  </td>
                </tr>

                <tr>
                  <th style="width: 70%" class="fw-normal">Success Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.successRows }}
                  </td>
                </tr>

                <tr>
                  <th style="width: 70%" class="fw-normal">Error Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.errorRows }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          *ngIf="uploadResult.errorRows > 0"
          (click)="viewErrorDetails()"
          [title]="'View Error Details'"
        >
          <mat-icon>list</mat-icon>
          View Errors
        </button>
        <button
          type="button"
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'BUTTONS.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  id="tagsModal"
  class="modal fade compact-inputs dropdown-pd-none"
  tabindex="-1"
  aria-labelledby="tagsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tagsModalLabel">
          <i class="bi bi-tags me-2"></i>{{ "Tag.TAG" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="mb-4">
          <label class="form-label fw-semibold mb-2 d-block">{{
            "Tag.ADD_TAG" | translate
          }}</label>
          <div class="d-flex flex-sm-nowrap flex-wrap align-items-center gap-1">
            <mat-form-field appearance="outline" class="w-100">
              <input
                #tagInput
                matInput
                type="text"
                (input)="onUserInput($event)"
                [(ngModel)]="inputValue"
                placeholder="{{ 'Tag.TAG_PLACE' | translate }}"
              />
            </mat-form-field>
            <button
              mat-stroked-button
              type="button"
              color="primary"
              class="icon-center icon-width"
              (click)="saveTags()"
              matTooltip="{{ 'Tag.ADD_TAGS' | translate }}"
              matTooltipPosition="above"
            >
              <mat-icon>add</mat-icon>
              <span>{{ "Tag.ADD" | translate }}</span>
            </button>
            <button
              mat-stroked-button
              type="button"
              class="icon-center icon-width"
              (click)="resetTagInput(tagInput)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <span class="d-flex align-items-center mt-1">
            <i class="bi bi-info-circle text-muted me-2"></i>
            <small class="smalltag">{{ "Tag.TAG_INFO" | translate }}</small>
          </span>
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label fw-semibold mb-0">{{
              "Tag.Available_Tags" | translate
            }}</label>
            <span class="badge bg-secondary"
              >{{ filteredTagsList.length }} {{ "Tag.TAG" | translate }}</span
            >
          </div>
          <div
            class="border rounded p-2"
            style="max-height: 250px; overflow-y: auto"
          >
            <div
              class="form-check mb-2"
              *ngFor="let tag of filteredTagsList; let i = index"
            >
              <div class="d-flex align-items-center">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  [id]="'tagCheckbox' + i"
                  [checked]="selectedTags.includes(tag)"
                  (change)="onTagCheckboxChange(tag, $event)"
                />
                <label
                  class="form-check-label flex-grow-1"
                  [for]="'tagCheckbox' + i"
                >
                  <span
                    class="badge bg-light text-dark border px-3 py-2 w-100 text-start"
                  >
                    <i class="bi bi-tag-fill text-primary me-2"></i>
                    {{ tag }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
        >
          {{ "Tag.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
